import ContentPage from '@glass/rock/components/ContentPage/ContentPage';

import industryPageGetStaticProps from '@glass/shared/modules/content/pages/industryPageGetStaticProps';
import getIndustryStaticPaths from '@glass/shared/modules/industries/getIndustryStaticPaths';

export const getStaticPaths = getIndustryStaticPaths;

export const getStaticProps = industryPageGetStaticProps;

export default ContentPage;
